import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ProductService } from '../../shared/product.service';
import { Product } from "../../models/Product";

@Component({
  selector: 'ciu-window-details',
  templateUrl: './window-details.component.html',
  styleUrls: ['./window-details.component.css']
})
export class WindowDetailsComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private productService: ProductService
  ) { }

  window$: any;
  window: Product;
  ngOnInit() {
    // this.window$ = this.route.params
    //   .switchMap((params: Params) => { return this.productService.getWindowById(params['id'])})
    //   .subscribe((window: Product) => {
    //     this.window = window;
    //   });;

    this.route.params
      .switchMap((params: Params) => {
        return this.productService.getWindowById(params['id']);
      })
      .subscribe((product: Product) => {
        this.window = product;
      });
  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/product-window/window-details/window-details.component.ts